import React from 'react'
import ReactDOM from 'react-dom/client'

import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'

import { store, persistor } from 'store/store'

import App from './App'
import theme from './theme'
import './index.css'

import './translations/i18n'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </ThemeProvider>
    </MuiThemeProvider>
  </Provider>,
)
